// FilterDialog.js
import {
  defineComponent,
  ref,
  computed,
  watch,
  inject,
  nextTick,
} from "/Scripts/vue.esm-browser.js";
import BudgetFilter from "/Component/Shop/filter/BudgetFilter.js";
import DatepickerFilter from "/Component/Shop/filter/DatepickerFilterM.js";
const html = String.raw;
export default defineComponent({
  name: "FilterDialog",
  components: {
    BudgetFilter,
    DatepickerFilter,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    groupData: {
      type: Array,
      required: true,
    },
    filteredDataByGroup: {
      type: Array,
      required: true,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:filters", "reset-filters", "toggle-filter"],
  inject: ["groupShowType"],
  setup(props, { emit }) {
    const priceRangeKey = ref(Date.now());
    const filteredDataByGroup = computed(() => props.filteredDataByGroup);
    const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
    const groupShowType = inject("groupShowType");
    const sorts = inject("sorts");
    const compareGroups = inject("compareGroups");
    const isVisible = ref(false);
    const isActive = ref(false);
    const modalContentRef = ref(null);
    const tempGroupType = ref(""); //顯示方式暫存
    const tempPriceRange = ref([0, 0]); //價格暫存
    const tempDateRange = ref([0, 0]); //日期暫存
    //const tempDateStart = ref(""); //日期起始暫存
    //const tempDateEnd = ref(""); //日期結束暫存
    const tempWeekDay = ref(new Set()); //星期幾暫存
    const tempDayRange = ref([]); //旅遊天數暫存
    const tempFeatureTags = ref(new Set()); //特色標籤暫存
    const tempAirline = ref(new Set()); //航空公司暫存

    const selectedIndex = ref(-1);

    //預算
    const priceRangeMin = computed(() =>
      props.groupData
        .flatMap((group) => group.groups.flatMap((item) => item.sitePrice))
        .reduce((min, price) => Math.min(min, price), Infinity),
    );
    const priceRangeMax = computed(() =>
      props.groupData
        .flatMap((group) => group.groups.flatMap((item) => item.sitePrice))
        .reduce((max, price) => Math.max(max, price), -Infinity),
    );
    //日期
    const dateRangeStart = computed(
      () =>
        props.groupData
          .flatMap((group) => group.groups.flatMap((item) => item.leaveDate))
          .sort()[0],
    );
    const dateRangeEnd = computed(
      () =>
        props.groupData
          .flatMap((group) => group.groups.flatMap((item) => item.leaveDate))
          .sort()[
          props.groupData.flatMap((group) =>
            group.groups.flatMap((item) => item.leaveDate),
          ).length - 1
        ],
    );

    const airlines = computed(() => {
      // Get all unique airline codes first
      const allAirlineCodes = props.groupData
        .flatMap((group) => group.groups)
        .flatMap((item) => item.airlineCodes)
        .filter((item) => item);
      const uniqueAirlines = [...new Set(allAirlineCodes)];

      // Count groups containing each airline code
      const airlineGroupCount = {};

      uniqueAirlines.forEach((airline) => {
        // For each airline, count how many group.groups entries contain it
        const count = props.groupData.reduce((total, group) => {
          // Count matching groups in this parent group
          const matchingGroups = group.groups.filter((item) =>
            item.airlineCodes.includes(airline),
          ).length;

          return total + (matchingGroups > 0 ? 1 : 0);
        }, 0);

        airlineGroupCount[airline] = count;
      });

      // Sort airline codes by their group count (descending)
      return uniqueAirlines.sort(
        (a, b) => airlineGroupCount[b] - airlineGroupCount[a],
      );
    });
    const tags = computed(() => {
      // Get all unique airline codes first
      const allTags = props.groupData.flatMap((group) => group.hashTagList);
      const uniqueTags = [...new Set(allTags)];
      return uniqueTags;
    });
    const availableWeekdays = computed(() => {
      const days = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekdays = [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ];
      return weekdays.filter((day) => {
        const dayIndex = days.indexOf(day);
        return props.groupData.some((group) =>
          group.groups.some((item) => {
            const itemDay = new Date(item.leaveDate).getDay();
            return itemDay === dayIndex;
          }),
        );
      });
    });
    const availableDayRanges = computed(() => {
      return props.filters.dayRanges
        .map((range, index) => ({ ...range, originalIndex: index }))
        .filter((range) => {
          return props.groupData.some((group) =>
            group.groups.some((item) => {
              const days = item.groupDay;

              if (range.rangeStart === 0) {
                return days <= range.rangeEnd;
              } else if (range.rangeEnd === 0) {
                return days >= range.rangeStart;
              } else {
                return days >= range.rangeStart && days <= range.rangeEnd;
              }
            }),
          );
        });
    });
    // Handle price range update (simplified, you might want to use a slider library)
    const updatePriceRange = ({ min, max }) => {
      tempPriceRange.value = [min, max];
    };

    // Handle date range update
    const updateDateRange = (start, end) => {
      tempDateRange.value = [start, end];
    };
    const updateCheckbox = (key, value, checked) => {
      if (key === "selectedWeekdays") {
        checked
          ? tempWeekDay.value.add(value)
          : tempWeekDay.value.delete(value);
      } else if (key === "dayRanges") {
        const updatedDayRanges = [...tempDayRange.value];
        updatedDayRanges[value] = {
          ...updatedDayRanges[value],
          active: checked,
        };
        tempDayRange.value = updatedDayRanges;
      } else if (key === "featureTags") {
        checked
          ? tempFeatureTags.value.add(value)
          : tempFeatureTags.value.delete(value);
      } else if (key === "selectedAirlines") {
        checked
          ? tempAirline.value.add(value)
          : tempAirline.value.delete(value);
      }
      //emit("update:filters", newFilters);
    };
    const reset = () => {
      tempGroupType.value = "horizontal";
      tempPriceRange.value = [
        props.filters.defaultPriceRange[0] || 0,
        props.filters.defaultPriceRange[1] || 0,
      ];
      tempDateRange.value = [
        props.filters.defaultDateRange[0] || 0,
        props.filters.defaultDateRange[1] || 0,
      ];
      tempWeekDay.value = new Set([]);
      tempDayRange.value = [
        { rangeStart: 1, rangeEnd: 2, active: false },
        { rangeStart: 3, rangeEnd: 5, active: false },
        { rangeStart: 5, rangeEnd: 7, active: false },
        { rangeStart: 7, rangeEnd: 10, active: false },
        { rangeStart: 10, rangeEnd: 0, active: false },
      ];
      tempFeatureTags.value = new Set([]);
      tempAirline.value = new Set([]);
    };
    const submit = () => {
      const newFilters = { ...props.filters };

      //送出後把temp資料都放回去filter

      //顯示
      groupShowType.value = tempGroupType.value;
      //預算
      newFilters.priceRange = tempPriceRange.value;
      //日期
      newFilters.dateRange = tempDateRange.value;
      //出發星期
      newFilters.selectedWeekdays = new Set(tempWeekDay.value || []);
      //旅遊天數
      newFilters.dayRanges = tempDayRange.value || [];
      //特色標籤
      newFilters.featureTags = new Set(tempFeatureTags.value || []);
      //航空公司
      newFilters.selectedAirlines = new Set(tempAirline.value || []);

      //最後更新filter
      emit("update:filters", newFilters);

      mobileFilterPopup.value = false;
    };

    const handleOverlayClick = (e) => {
      // 如果點擊的是 modal 外部，就關閉
      if (modalContentRef.value && !modalContentRef.value.contains(e.target)) {
        mobileFilterPopup.value = false;
      }
    };

    watch(
      () => props.filters,
      (newFilters) => {
        //初始化
        tempPriceRange.value[0] = newFilters.priceRange[0] || 0;
        tempPriceRange.value[1] = newFilters.priceRange[1] || 0;
        tempDateRange.value[0] = newFilters.dateRange[0] || "";
        tempDateRange.value[1] = newFilters.dateRange[1] || "";
        tempWeekDay.value = new Set(newFilters.selectedWeekdays || []);
        tempFeatureTags.value = new Set(newFilters.featureTags || []);
        tempAirline.value = new Set(newFilters.selectedAirlines || []);
        tempDayRange.value = newFilters.dayRanges || [];
      },
      { deep: true },
    );
    watch(
      () => mobileFilterPopup.value,
      async (newVal) => {
        if (newVal) {
          isVisible.value = true;
          await nextTick();
          setTimeout(() => {
            isActive.value = true;
            // BindCompareButton(compareGroups.value);
          }, 2);
        } else {
          isActive.value = false;
          setTimeout(() => {
            isVisible.value = false;
          }, 400);
        }
      },
      { immediate: true },
    );
    watch(
      () => groupShowType.value,
      async (newVal) => {
        if (newVal) {
          tempGroupType.value = newVal;
        }
      },
      { immediate: true },
    );

    return {
      isVisible,
      isActive,
      mobileFilterPopup,
      priceRangeMin,
      priceRangeMax,
      dateRangeStart,
      dateRangeEnd,
      updatePriceRange,
      updateDateRange,
      updateCheckbox,
      availableWeekdays,
      availableDayRanges,
      tags,
      airlines,

      tempGroupType,
      tempWeekDay,
      tempFeatureTags,
      tempAirline,
      tempPriceRange,
      tempDateRange,
      reset,
      submit,
      priceRangeKey,
      modalContentRef,
      handleOverlayClick,
    };
  },
  template: html`
    <div
      class="filter_dialog Com_PopupBg"
      :style="{ display: isVisible ? 'block' : 'none' }"
      :class="{ active: isActive }"
      @click="handleOverlayClick"
    >
      <div class="modal-content Com_halfPopup" ref="modalContentRef">
        <div class="modal_header">
          <button class="close_btn" @click="mobileFilterPopup = false">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.8 28L0 25.2L11.2 14L0 2.8L2.8 0L14 11.2L25.2 0L28 2.8L16.8 14L28 25.2L25.2 28L14 16.8L2.8 28Z"
                fill="#8A8A8A"
              />
            </svg>
          </button>
        </div>
        <div class="modal_body scrollbarWidth">
          <div class="filter_content">
            <BudgetFilter
              :key="'test'+(priceRangeMin + priceRangeMax)||'loading' "
              :minValue="priceRangeMin"
              :maxValue="priceRangeMax"
              :priceRange="tempPriceRange"
              @update:range="updatePriceRange"
            />
            <DatepickerFilter
              :dateRangeStart="dateRangeStart"
              :dateRangeEnd="dateRangeEnd"
              :dateRange="tempDateRange"
              @update:updateDateRange="updateDateRange"
            />

            <div class="filterbox state">
              <div class="filter_title">出團狀態</div>
              <div class="filterSpace_checkbox">
                <div class="filter_checkbox">
                  <input class="checkbox_input" type="checkbox" id="s-1" />
                  <label class="checkbox_label" for="s-1">
                    <div class="checkbox_textBox">
                      <span>保證出發</span>
                    </div>
                  </label>
                </div>
                <div class="filter_checkbox">
                  <input class="checkbox_input" type="checkbox" id="s-2" />
                  <label class="checkbox_label" for="s-2">
                    <div class="checkbox_textBox">
                      <span>即將成團</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="filterbox">
              <div class="filter_title">出發星期</div>
              <div class="filterSpace_checkbox">
                <div
                  class="filter_checkbox"
                  v-for="day in availableWeekdays"
                  :key="day"
                >
                  <input
                    class="checkbox_input"
                    type="checkbox"
                    :id="'Www-' + day"
                    :checked="tempWeekDay.has(dayIndex(day))"
                    @change="updateCheckbox('selectedWeekdays', dayIndex(day), $event.target.checked)"
                  />
                  <label class="checkbox_label" :for="'Www-' + day">
                    <div class="checkbox_textBox">
                      <span>{{ day }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="filterbox">
              <div class="filter_title">旅遊天數</div>
              <div class="filterSpace_checkbox">
                <div
                  class="filter_checkbox"
                  v-for="(range, index) in availableDayRanges"
                  :key="range.originalIndex"
                >
                  <input
                    class="checkbox_input"
                    type="checkbox"
                    :id="'Wdd-' + range.originalIndex"
                    :checked="range.active"
                    @change="updateCheckbox('dayRanges', range.originalIndex, $event.target.checked)"
                  />
                  <label
                    class="checkbox_label"
                    :for="'Wd-' + range.originalIndex"
                  >
                    <div class="checkbox_textBox">
                      <span>
                        {{ range.rangeStart === 0 ? range.rangeEnd + '天以下' :
                        range.rangeEnd === 0 ? range.rangeStart + '天以上' :
                        range.rangeStart + '~' + range.rangeEnd + '天' }}
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="filterbox">
              <div class="filter_title">特色標籤</div>
              <div class="filterSpace_tags">
                <div class="filter_tag" v-for="tag in tags" :key="tag">
                  <input
                    class="checkbox_input"
                    type="checkbox"
                    :id="'Wee-' + tag"
                    :checked="tempFeatureTags.has(tag)"
                    @change="updateCheckbox('featureTags', tag, $event.target.checked)"
                  />
                  <label class="tag_label" :for="'Wee-' + tag">
                    <div class="tag_text">
                      <span>{{ tag }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="filterbox">
              <div class="filter_title">航空公司</div>
              <div class="filterSpace_checkbox flight">
                <div
                  class="filter_checkbox"
                  v-for="airline in airlines"
                  :key="airline"
                >
                  <input
                    class="checkbox_input"
                    type="checkbox"
                    :id="'Wff-' + airline"
                    :checked="tempAirline.has(airline)"
                    @change="updateCheckbox('selectedAirlines', airline, $event.target.checked)"
                  />
                  <label class="checkbox_label" :for="'Wff-' + airline">
                    <div class="checkbox_textBox">
                      <span> {{ airlineName(airline) }} </span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal_footer">
          <div class="btn_group">
            <button class="clean_btn" @click="reset">清除全部</button>
            <button class="filter_btn" @click="submit">送出</button>
          </div>
        </div>
      </div>
    </div>
  `,
  methods: {
    dayIndex(day) {
      const days = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      return days.indexOf(day);
    },
    airlineName(code) {
      return transService.airlineMap[code];
    },
    getSubName: function (showField) {
      //移除括號內的內容
      const result = showField.replace(/（.*?）/g, "");
      return result;
    },
    setGroupShowType(groupShowType) {
      this.groupShowType = groupShowType;
    },
  },
});
